import React from "react"
import Layout from "../Layout"
import Contact from "../Contact"
import Gallery from "../Gallery"
import Hero from "../Hero"
import Numbers from "../Numbers"
import Summary2026 from "../Summary2026"

const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <Hero lang={lang} type="hero2026" />
    <Numbers lang={lang} type="summary2026" />
    <Gallery lang={lang} />
    <Summary2026 lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage
